import { mapState, mapActions } from 'vuex';

import TimeAndAgo from '@/components/TimeAndAgo.vue';

export default {
  name: 'QuestionReferralList',

  components: {
    'time-and-ago': TimeAndAgo,
  },

  computed: {
    ...mapState('QA/Question', {
      ms_questionReferralList: 'questionReferralList',
    }),
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_getQuestionReferralInQuestion: 'getQuestionReferralInQuestion',
    }),

    getQuestionReferralInQuestion() {
      this.ma_getQuestionReferralInQuestion(this.$route.params.id);
    },
  },

  created() {
    this.getQuestionReferralInQuestion();
  },
};
